import { type MoveEvent, TYPE_MASK, WHITE, ZOMBIE_PAWN, graves, pieceColor, risingNext } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const GRAVE = '/art/grave.svg';
const rose = (e: MoveEvent) => e.t === 'fx' && e.kind === 'rise';

export const zombieUi: VariantUi = {
  heroImage: '/art/zombie.svg',
  peek: [{}, { image: '/art/bK.svg' }, {}, { image: GRAVE }, { image: '/art/wP-zombie.svg', threat: true }, { image: GRAVE }, {}, {}, {}],

  pieceImage(_pos, _sq, piece) {
    if ((piece & TYPE_MASK) !== ZOMBIE_PAWN) return null;
    return `/art/${pieceColor(piece) === WHITE ? 'w' : 'b'}P-zombie.svg`;
  },

  decorations(pos) {
    const out: Decoration[] = [];
    for (const g of graves(pos)) {
      const who = g.owner === WHITE ? 'White' : 'Black';
      out.push({ kind: 'tile', sq: g.sq, image: GRAVE, title: `Rises for ${who} ${g.turns === 1 ? 'when the square is free' : `in ${g.turns} turns`}` });
    }
    return out;
  },

  twist(pos, you) {
    const me = you ?? pos.turn;
    const mine = risingNext(pos, me).length;
    const theirs = risingNext(pos, me === WHITE ? 1 : 0).length;
    const whose = you === null ? (me === WHITE ? 'White' : 'Black') : 'You';
    if (mine) return { text: `${mine === 1 ? 'A zombie rises' : `${mine} zombies rise`} for ${you === null ? whose : 'you'} after ${you === null ? 'their' : 'your'} next move` };
    if (theirs) return { text: `${theirs === 1 ? 'A zombie rises' : `${theirs} zombies rise`} for ${you === null ? 'the other side' : 'them'} next move`, alert: you !== null };
    const n = graves(pos).length;
    return { text: n ? `${n} ${n === 1 ? 'grave' : 'graves'} waiting to open` : 'Everything you capture comes back for you as a zombie' };
  },

  eventSound(e) {
    return rose(e) ? 'rise' : null;
  },

  moveBadge(rec) {
    return rec.events.some(rose) ? { icon: '/art/zombie.svg', title: 'A zombie rose' } : null;
  },
};
